import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 3500 }
  }

  connect() {
    this.dismissTimer = window.setTimeout(() => this.close(), this.timeoutValue)
  }

  disconnect() {
    window.clearTimeout(this.dismissTimer)
    window.clearTimeout(this.removeTimer)
  }

  close() {
    this.element.classList.add("translate-y-2", "opacity-0")
    this.removeTimer = window.setTimeout(() => this.element.remove(), 180)
  }
}
